import { PlusOutlined } from '@ant-design/icons';
import { FC } from 'react';

interface AddReminderTextProps {
  timeUnit: number;
  timeUnitType: string | undefined;
  renderUnitType: (
    unitType: string | undefined,
    timeUnit: number | undefined,
  ) => 'Year' | 'Years' | 'Month' | 'Months' | 'Week' | 'Weeks' | 'Day' | 'Days';
}

const AddReminderText: FC<AddReminderTextProps> = ({ timeUnit, timeUnitType, renderUnitType }) => {
  if (timeUnit) {
    return <>{`${timeUnit} ${renderUnitType(timeUnitType, timeUnit)} earlier`}</>;
  }

  return (
    <>
      <PlusOutlined /> Add reminder
    </>
  );
};

export { AddReminderText };
